import { FC } from "react";
import { useDidMount } from "rooks";
import Stack from "@mui/material/Stack";
import { UtilizationAndCoverageDrawerChart } from "@/components/pages/commtiments/utilization-and-coverage/components/drawers/common/UtilizationAndCoverageDrawerChart";
import { SavingsPlanDrawerChartHeader } from "@/components/pages/commtiments/utilization-and-coverage/components/drawers/savings-plan-drawer/SavingsPlanDrawerChartHeader";
import { UtilizationAndCoverageDrawerDataGrid } from "@/components/pages/commtiments/utilization-and-coverage/components/drawers/common/data-grid/UtilizationAndCoverageDrawerDataGrid";
import { useAppDispatch } from "@/store/hooks";
import { getUtilizationAndCoverageDetailsThunk } from "@/store/commitments/thunks/getUtilizationAndCoverageDetailsThunk";

export const SavingsPlanDrawerUtilizationTab: FC = () => {
  const dispatch = useAppDispatch();

  useDidMount(() => {
    dispatch(getUtilizationAndCoverageDetailsThunk());
  });

  return (
    <Stack px={0.5} bgcolor="white">
      <UtilizationAndCoverageDrawerChart
        ChartHeader={SavingsPlanDrawerChartHeader}
        type="utilization"
      />

      <UtilizationAndCoverageDrawerDataGrid viewTab="commitment" />
    </Stack>
  );
};
